export enum SmsStatus {
  Active = 1,
  Inactive = 2,
  Waiting = 3,
  Denied = 4,
}

export enum SmsStatusContext {
  Active = 'Hoạt động',
  Inactive = 'Ngưng hoạt động',
  Waiting = 'Đang chờ duyệt',
  Denied = 'Từ chối duyệt',
}

export const SmsArray = [
  { [SmsStatus.Active]: SmsStatusContext.Active },
  { [SmsStatus.Inactive]: SmsStatusContext.Inactive },
  { [SmsStatus.Waiting]: SmsStatusContext.Waiting },
  { [SmsStatus.Denied]: SmsStatusContext.Denied },
];

export class SmsConst {
  static displayColumns = () => {
    return [
      {
        title: 'Brandname',
        key: 'brand_name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Mô tả',
        key: 'note',
        display: true,
        allowSort: false,
        classes: '',
      },
      // {title: 'Trạng thái', key: 'display_status', display: true, allowSort: false, classes: ''},
    ];
  };
  static statusString = status => {
    switch (status) {
      case SmsStatus.Active:
      case SmsStatus.Active.toString():
        return `<small class="badge badge-success">` + SmsStatusContext.Active + `</small>`;
      case SmsStatus.Inactive:
      case SmsStatus.Inactive.toString():
        return `<small class="badge badge-danger">` + SmsStatusContext.Inactive + `</small>`;
      case SmsStatus.Waiting:
      case SmsStatus.Waiting.toString():
        return `<small class="badge badge-warning">` + SmsStatusContext.Waiting + `</small>`;
      case SmsStatus.Denied:
      case SmsStatus.Denied.toString():
        return `<small class="badge badge-danger">` + SmsStatusContext.Denied + `</small>`;
      default:
        return `<small class="badge badge-default">` + status + `</small>`;
    }
  };
  static statusAction(status) {
    switch (status) {
      case SmsStatus.Active:
      case SmsStatus.Active.toString():
        return true;
      case SmsStatus.Inactive:
      case SmsStatus.Inactive.toString():
        return false;
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/sms/sms.const.ts